import Add from "../../../../assets/icon/svg/add"
import { CLIENT_KEY_FB, REDIRECT_URI } from "../../../../config/config"
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import FacebookIcon from '../../../../assets/icon/svg/mxh/facebook';
import { fetchPageFacebook } from '../../../../store/action/pageFacebookAction';
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

const Facebook = (props) => {
   const { fetchPageFacebook } = props;
   const navigate = useNavigate();

   const responseFacebook = (response) => {
      if (response.status !== 'unknown') {
         fetchPageFacebook(response, navigate);
      }
   }

   return (
      <div className="app-sh-connect-channel--item">
         <div className="app-stack app-stack--align-center">
            <div className="app-stack--item app-connect-channel--item-icon_sku">
               <div className="app-sh-connect-channel--item-icon__main">
                  <div
                     className="app-sh-connect-channel--item-icon__main-item app-sh-connect-channel--item-icon__main-item--1">
                     <FacebookIcon />
                  </div>
               </div>
            </div>
            <div className="app-stack--item app-stack--item-fill">
               <div className="app-sh-connect-channel--item-title">
                  Facebook
               </div>
               <div className="app-sh-connect-channel--item-content">
                  Bán và tạo đơn hàng trực
                  tiếp trên Meta Business Suite, quản lý tất cả các comment, inbox, thông
                  tin khách hàng và tạo vận chuyển đơn hàng.
               </div>
            </div>
            <FacebookLogin
               appId={CLIENT_KEY_FB}
               fields="name,email"
               scope='email,pages_manage_ads,pages_manage_metadata,pages_read_engagement,pages_read_user_content,pages_manage_posts,pages_manage_engagement,pages_messaging,pages_messaging_phone_number,ads_management,business_management,page_events,instagram_basic,instagram_manage_comments,instagram_manage_messages,pages_messaging_subscriptions'
               callback={responseFacebook}
               isMobile={false}
               redirectUri={REDIRECT_URI}
               render={(renderProps) => (
                  <div className="app-stack--item" onClick={renderProps.onClick}>
                     <a className="app-btn app-btn-primary app-connect-channel--item-link" >
                        <span>
                           <Add />
                        </span>
                        <span style={{ color: 'white' }}>
                           Thêm kết nối
                        </span>
                     </a>
                  </div>
               )}
            />

         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { pageFacebook } = state;

   return {
      pageFacebook
   };
};

export default connect(mapStateToProps, {
   fetchPageFacebook,
})(Facebook);
